/**
 * @author Harshitha.k
 * @description 
 */

import axios from 'axios';
import moment from 'moment';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import React, { useState, useEffect, useRef } from 'react';
import ConfigEditor from './ConfigEditor';
import Highlighter from 'react-highlight-words';
import config from '../../../constants/config.json';
import MobileConfigEditor from './MobileConfigEditor';
import localStorage from '../../../utils/localStorage';
import HeaderCustomization from './HeaderCustomization';
import StyledTable from "../../../commons/styles/table";
import { LOGBOOK } from '../../../commons/api';
import { EditOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { Drawer, Row, Col, Input, Select, Checkbox, message, Form, Button } from 'antd';
import {
  getDatasourceData,
  // getRecurrencePatternData,
  getFormTypeData,
  getLocationData,
  // getELogTypeData
} from './ElogConfigCalls';
import {
  DrawerFooter,
  StyledContentRight,
  StyledHomepage
} from '../../../commons/styles/layout';

const { Option } = Select;

const ELogBookConfiguration = (props) => {
  const [visible, setVisible] = useState(false);
  const [visibleData, setVisibleData] = useState(false);
  const [editObj, setEditObj] = useState({});
  const [locationList, setLocationList] = useState([]);
  const [userProfile, setUserProfile] = useState(props.userProfile);
  // const [eLogTypeList, setELogTypeList] = useState([]);
  // const [recurrencePatternList, setRecurrencePatternList] = useState([]);
  const [formTypeList, setFormTypeList] = useState([]);
  const [datasource, setDatasource] = useState([]);
  const [searchText, setSearchText] = useState('');
  const elogConfig = useRef();

  useEffect(() => {
    _getDataSource();
    // _getRecurrencePattern();
    _getFormType();
    _getLocation();
    // _getELogType();
  }, []);

  useEffect(() => {
    if (userProfile) {
      setUserProfile(userProfile);
    }
  }, [userProfile]);

  const _getLocation = async () => {
    const locationList = await getLocationData();
    setLocationList(locationList);
  };

  // const _getELogType = async () => {
  //   const eLogTypeList = await getELogTypeData();
  //   setELogTypeList(eLogTypeList);
  // };

  const _getDataSource = async () => {
    const datasource = await getDatasourceData();
    setDatasource(datasource);
  };

  // const _getRecurrencePattern = async () => {
  //   const recurrencePatternList = await getRecurrencePatternData();
  //   setRecurrencePatternList(recurrencePatternList);
  // };

  const _getFormType = async () => {
    let formTypeList = await getFormTypeData();
    setFormTypeList(formTypeList);
  };

  const onClose = () => {
    if (elogConfig.current) {
      elogConfig.current.resetFields();
    }
    setVisible(false);
    setEditObj({});
  };

  const addHeaderColumn = () => {
    let updatedEditObj = { ...editObj };
    if (updatedEditObj && !updatedEditObj.JSONFormat) {
      updatedEditObj = {
        ...updatedEditObj,
        JSONFormat: {
          header: [
            {
              name: '',
              key: ''
            }
          ],
          form: {
            datasource: [],
            columns: []
          }
        }
      };
    } else {
      updatedEditObj = {
        ...updatedEditObj,
        JSONFormat: {
          form: {
            datasource:
              updatedEditObj &&
                updatedEditObj.JSONFormat &&
                updatedEditObj.JSONFormat.form &&
                updatedEditObj.JSONFormat.form['datasource']
                ? updatedEditObj.JSONFormat.form['datasource']
                : [],
            columns:
              updatedEditObj &&
                updatedEditObj.JSONFormat &&
                updatedEditObj.JSONFormat.form &&
                updatedEditObj.JSONFormat.form['columns']
                ? updatedEditObj.JSONFormat.form['columns']
                : []
          },
          header: [
            ...(updatedEditObj.JSONFormat['header'] || []),
            {
              name: '',
              key: ''
            }
          ]
        }
      };
    }
    setEditObj(updatedEditObj); // Update state
  };

  // const addColumn = () => {
  //   let updatedEditObj = { ...editObj };
  //   if (updatedEditObj && !updatedEditObj.JSONFormat) {
  //     updatedEditObj.JSONFormat = {
  //       header: [],
  //       form: {
  //         datasource: [],
  //     };
  //   } else {
  //     updatedEditObj.JSONFormat.form.columns.push({ displayName: 'New Column', key: '', width: '', widget: 'input', placeHolder: '' });
  //   }
  //   setEditObj(updatedEditObj);
  // };

  const _addELogBook = () => {
    if (elogConfig.current) {
      elogConfig.current.resetFields();
    }
    setVisible(true);
    setVisibleData(visibleData);
    setEditObj({});
  };

  const updateElog = async (e) => {
    e.preventDefault();
    const values = await elogConfig.current.validateFields();
    const payload = {
      ...editObj,
      ...values,
      ModifiedBy: userProfile?.user?.Id || 0,
      ModifiedDate: moment().format('YYYY-MM-DD HH:mm:ss')
    };
    _updateELOG(payload);
  };

  const _updateELOG = (payload) => {
    let siteId = localStorage.get('currentSite');
    let accessToken = localStorage.get('accessToken');
    const headers = {
      method: 'PATCH',
      url: `${LOGBOOK.UPDATE}?SiteId=${siteId}`, // Make sure LOGBOOK is accessible here
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      },
      data: payload
    };
    axios(headers)
      .then(() => {
        setVisible(false);
        setEditObj({});
        if (elogConfig.current) {
          elogConfig.current.resetFields();
        }
        _getDataSource();
        message.success('Updated Successfully');
      })
      .catch((err) => {
        if (err.response && (err.response.status === 400 || err.response.status === 500)) {
          message.info(err.response.data.message);
        } else {
          message.error('An error occurred.'); // Handle cases where err.response is undefined
        }
      });
  };

  const saveElog = async (e) => {
    e.preventDefault();
    const values = await elogConfig.current.validateFields();
    if (Object.keys(editObj).length === 0) {
      message.error('Please provide atleast one header column');
      return;
    }
    const payload = {
      ...values,
      JSONFormat: editObj.JSONFormat,
      MobileJSON: editObj.MobileJSON,
      CreatedBy: userProfile?.user?.Id || 0,
      CreatedDate: moment().format('YYYY-MM-DD HH:mm:ss'),
      ModifiedBy: null,
      ModifiedDate: null
    };
    _saveELOG(payload);
  };

  const _saveELOG = (payload) => {
    let siteId = localStorage.get('currentSite');
    let accessToken = localStorage.get('accessToken');
    const headers = {
      method: 'POST',
      url: `${LOGBOOK.CREATE}?SiteId=${siteId}`, // Make sure LOGBOOK is accessible here
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      },
      data: payload
    };
    axios(headers)
      .then(() => {
        setVisible(false);
        if (elogConfig.current) {
          elogConfig.current.resetFields();
        }
        _getDataSource();
        message.success('Saved Successfully');
      })
      .catch((err) => {
        if (err.response && (err.response.status === 400 || err.response.status === 500)) {
          message.info(err.response.data.message);
        } else {
          message.error('An error occurred.'); // Handle cases where err.response is undefined
        }
      });
  };

  const columnEditorObject = (form) => {
    if (form) {
      const updatedEditObj = {
        ...editObj,
        JSONFormat: {
          form,
          header: editObj.JSONFormat.header || []
        },
        MobileJSON: {
          form,
          header: editObj.MobileJSON.header || []
        }
      };
      setEditObj(updatedEditObj);
    }
  };

  const columnEditorObjectMobile = (form) => {
    if (form) {
      const updatedEditObj = {
        ...editObj,
        MobileJSON: {
          form: form || [],
          header: editObj.MobileJSON.header || []
        }
      };
      setEditObj(updatedEditObj);
    }
  };

  const columnHeaderSaveObject = (columns) => {
    if (columns) {
      // const updatedEditObj = {
      //   ...editObj,
      //   // JSONFormat: {
      //   //   ...(editObj && editObj.JSONFormat ? editObj.JSONFormat : {}),
      //   //   columns
      //   // },
      //   MobileJSON: {
      //     ...(editObj && editObj.JSONFormat ? editObj.JSONFormat : {}),
      //     columns
      //   }
      // };
      setEditObj((prevEditObj) => ({
        ...prevEditObj,
        JSONFormat: {
          ...prevEditObj.JSONFormat,
          header: columns,
          form: {
            ...((prevEditObj.JSONFormat && prevEditObj.JSONFormat.form) || {
              datasource: [],
              columns: []
            })
          }
        },
        MobileJSON: {
          ...(editObj && editObj.JSONFormat ? editObj.JSONFormat : {}),
          columns
        }
      }));
    }
  };

  const handleFormTypeChange = (value) => {
    setEditObj((prevEditObj) => ({
      ...prevEditObj,
      FormType: value,
    }));
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type='primary'
          onClick={() => handleSearch(selectedKeys, confirm)}

          style={{ width: 90, marginRight: 8 }}
        >
          <SearchOutlined />
          Search
        </Button>
        <Button
          type='primary'
          danger
          onClick={() => handleReset(clearFilters)}

          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const translation = (keyword) => {
    return props.translationCache[keyword] || keyword;
  };

  const columns = [
    {
      title: translation('Logbook ID'),
      dataIndex: 'ShortDescription',
      key: 'ShortDescription',
      ...getColumnSearchProps('ShortDescription'),
      render: (text, record) => (
        <Link to={{ pathname: `/rubus/Logbook/${record.LogBookId}` }}>
          {text}
        </Link>
      )
    },
    {
      title: translation('Location'),
      dataIndex: 'Location',
      key: 'Location'
    },
    {
      title: translation('Form Type'),
      dataIndex: 'FormType',
      key: 'FormType'
    },
    {
      title: translation('Action'),
      width: '600',
      render: (text, record) => (
        <Button
          type="primary"
          onClick={() => {
            if (elogConfig.current) {
              elogConfig.current.setFieldsValue(record);
            }
            setVisible(true);
            setEditObj(record);
          }}
        >
          <EditOutlined />
        </Button>
      )
    }
  ];
  const permissionsArray = [];
  const siteId = localStorage.get('currentSite');
  userProfile &&
    userProfile['belongsTo'] &&
    userProfile['belongsTo']['sites'] &&
    userProfile['belongsTo']['sites'][siteId] &&
    userProfile['belongsTo']['sites'][siteId]['role'] &&
    userProfile['belongsTo']['sites'][siteId]['role']['Permission']
      .filter((item) => item.resource === 'elog_book')
      .map((name) => permissionsArray.push(name.action));

  return (
    <StyledHomepage>
      <StyledContentRight>
        <Button
          type='primary'
          icon={<PlusOutlined />}
          disabled={!permissionsArray.includes('create') ? true : false}
          onClick={_addELogBook}
        >
          {translation('Add Logbook')}
        </Button>
      </StyledContentRight>
      <Drawer
        title={translation('Edit Configuration')}
        placement="right"
        width={1100}
        closable
        onClose={onClose}
        open={visible}
      >
        <Form
          layout="vertical"
          ref={elogConfig}
          name="Site_form"
          initialValues={editObj}
        >
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" span={18}>
              <Form.Item
                label={translation('ELogBook Id')}
                name="LogBookId"
                rules={[{ required: true, message: 'Enter LogbookID' }]}
              >
                <Input
                  placeholder={translation('Please enter LogbookID')}
                  disabled={!!editObj.LogBookId}
                />
              </Form.Item>
              <Form.Item
                label={translation('ELogReference Id')}
                name="eLogReferenceId"
                rules={[{ required: true, message: 'Enter ELogReferenceId' }]}
              >
                <Input
                  placeholder={translation('Please enter eLogReferenceId')}
                  disabled={!!editObj.eLogReferenceId}
                />
              </Form.Item>
              <Form.Item
                label={translation('Location')}
                name="Location"
                rules={[{ required: true, message: 'Enter Location' }]}
              >
                <Select placeholder={translation('Please select Location')}>
                  {locationList.map((location, index) => (
                    <Option key={index} value={location.Name}>
                      {location.Name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                label={translation('ELogBook Name')}
                name="LongDescription"
                rules={[{ required: true, message: translation('Enter ELogBook Name') }]}
              >
                <Input
                  placeholder={translation('Please enter elogbook Name')}
                  disabled={!!editObj.LongDescription}
                />
              </Form.Item>
              <Form.Item
                label={translation('Description')}
                name="ShortDescription"
                rules={[{ required: true, message: translation('Enter Description') }]}
              >
                <Input.TextArea placeholder={translation('Please enter Description')} />
              </Form.Item>
              <Form.Item
                label={translation('Active/Inactive')}
                name="Status"
                rules={[{ required: false, message: translation('Enter Status') }]}
              >
                <Checkbox />
              </Form.Item>
              <Form.Item
                label={translation('Form Type')}
                name="FormType"
                rules={[{ required: true, message: translation('Enter formType') }]}
                onChange={handleFormTypeChange}            >
                <Select placeholder={translation('Please select FormType')}>
                  {formTypeList && Array.isArray(formTypeList) && formTypeList.map((formType, index) => (
                    <Option key={index} value={formType.Value}>
                      {formType.Key}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                label={translation('Process')}
                name="Process"
                rules={[{ required: true, message: 'Enter process' }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <div style={{ marginBottom: '50px' }}>
            <b>{translation('Header Configuration')}</b>
            <Button
              type='primary'
              onClick={addHeaderColumn}
              style={{ marginLeft: '5px', marginBottom: '20px' }}
            >
              {translation('Add Header Column')}
            </Button>
            {editObj.JSONFormat && editObj.JSONFormat['header'] ? (
              <HeaderCustomization
                columnsProperties={editObj && editObj.JSONFormat ? editObj.JSONFormat['header'] : []}
                columnSaveObject={columnHeaderSaveObject}
              />
            ) : null}
          </div>
          <div style={{ marginBottom: '50px' }}>
            <b>{translation('Web Configuration :')}</b>
            <ConfigEditor
              form={editObj.JSONFormat?.form || []}
              columnEditorObject={columnEditorObject}
            />
          </div>
          <div style={{ marginBottom: '50px' }}>
            <b>{translation('Mobile Configuration :')} </b>
            <MobileConfigEditor
              form={editObj.MobileJSON?.form || []}
              columnEditorObjectMobile={columnEditorObjectMobile}
            />
          </div>
        </Form>
        <DrawerFooter>
          {config.production !== true && (
            <Button type='primary' onClick={onClose} style={{ marginRight: 8 }}>
              {translation('Cancel')}
            </Button>
          )}
          {config.production !== true && (
            <span>
              {!editObj.LogBookId ? (
                <Button onClick={saveElog}>{translation('Create')}</Button>
              ) : (
                <Button onClick={updateElog}>
                  {translation('Update')}
                </Button>
              )}
            </span>
          )}
        </DrawerFooter>
      </Drawer>
      <StyledTable style={{marginTop:"20px"}} size="small" columns={columns} dataSource={datasource} />
    </StyledHomepage>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache,
  userProfile: state.LayoutReducer.loggedInProfile
});

export default connect(mapStateToProps)(ELogBookConfiguration);